import { DynamicForm, FormConfig } from "@components/DynamicForm/DynamicForm";
import { useNotification } from "@hooks/useNotification";
import { useQuery } from "@hooks/useQuery";
import { useDocumentDetails } from "@modules/ECMS/MAGP/ApprovalManagement/Drilldown.Hooks";
import { decodeHTML } from "@utils/CommonUtils";
import { useEffect } from "react";
import { FieldValues } from "react-hook-form";
import { useNavigate } from "react-router-dom";
import { ContentWrapper } from "~/Components";
import { useAuth } from "~/Hooks/useAuth";
import { post, put } from "~/Services";
import { centralizedHost } from "~/Utils";
import { appendSasToken } from "../../Imagehelper";
import { useSingleCabinLuggagePolicySection2 } from "../TravellersInfo.hook";
import { fields } from "../constants";

export const AddEditCentralizedSingleCabinLuggagePolicySection2 = () => {
  const query = useQuery();
  const navigate = useNavigate();
  const { openToast } = useNotification();
  const { user } = useAuth();

  const {
    data: editNewsData,
    error,
    isLoading: drilldownLoading,
    isError,
    refetch: refetcheditNews,
  } = useSingleCabinLuggagePolicySection2(query.get("editId") || "");

  const {
    data: newsById,
    isLoading: isLoadingNews,
    refetch: refetchDocument,
  } = useDocumentDetails(query?.get("id") || "");

  useEffect(() => {
    if (query.get("id")) {
      refetchDocument();
    }
    if (query.get("editId")) {
      refetcheditNews();
    }
  }, [query.get("editId"), query.get("id")]);

  const editNews = editNewsData as any;
  console.log(editNews?.[0], "datanews");

  const newsFormConfig: FormConfig = {
    initialValues: {
      title: decodeHTML(newsById ? newsById.payload.title : editNewsData ? editNewsData?.[0]?.title : ""),
      title_malay: decodeHTML(
        newsById ? newsById.payload.title_malay : editNewsData ? editNewsData?.[0]?.title_malay : ""
      ),
      title_mandarin: decodeHTML(
        newsById ? newsById.payload.title_mandarin : editNewsData ? editNewsData?.[0]?.title_mandarin : ""
      ),
      image: newsById?.payload
        ? decodeHTML([
            {
              uid: "-1",
              name: "newsImage.png",
              status: "done",
              url: appendSasToken(newsById?.payload?.image),
            },
          ])
        : decodeHTML([
            {
              uid: "-1",
              name: "newsImage.png",
              status: "done",
              url: appendSasToken(editNewsData?.[0]?.image),
            },
          ]),
      published: newsById
        ? decodeHTML(newsById.payload?.published)
        : editNewsData
          ? decodeHTML(editNewsData?.[0]?.published)
          : "",
    },
    fields: fields.centralizedSingleCabinLuggagePolicyPageImage,
  };

  const onSubmit = async (
    data: FieldValues,
    apiUrl: string,
    action: string,
    method: string,
    status: "DRAFT" | "PENDING",
    reviewNotes?: string
  ) => {
    let imageKeys: any = ["image"];
    for (const key of imageKeys) {
      const field = data[key];

      try {
        if (field?.[0]?.originFileObj) {
          const formData = new FormData();
          formData.append("upload-file", field[0].originFileObj);
          formData.append("application", "CENTRALIZED");
          const res: any = await post("management/upload-file", formData);
          if (res) data[key] = res.response.data;
        } else if (field?.[0]?.url) {
          const cleanUrl = field[0].url.split("?sp=")[0];
          data[key] = cleanUrl;
        } else if (Array.isArray(field) && field.length === 0) {
          data[key] = "";
        } else if (!field) {
          data[key] = "";
        }
      } catch (error) {
        console.error(`Error handling image field ${key}:`, error);
      }
    }
    const payload = {
      action: action,
      method: method,
      module: "Baggage Guide",
      subModule: "centralizedSingleCabinLuggagePolicy_centralizedSingleCabinLuggagePolicyPageImage",
      type: "CENTRALIZED",
      application: "CENTRALIZED",
      reviewNotes: reviewNotes,
      appList: [
        {
          appName: "CENTRALIZED",
          apiUrl: apiUrl,
        },
      ],
      payload: {
        ...(action === "UPDATE" && { id: editNewsData?.[0]?.id || newsById?.payload?.id }),
        ...data,
      },
      status: status,
    };
    if (query.get("id")) {
      put(`/management/update-document?approvalId=${query.get("id")}`, payload)
        .then((response: any) => {
          openToast({
            content: status == "PENDING" ? "Data Sent for Review" : "Data Saved Successfully",
            type: "success",
          });
          if (response.status === "OK" && status == "PENDING") {
            navigate("/centralized/status-information?activeTab=pending");
          } else {
            navigate("/centralized/status-information?activeTab=draft");
          }
        })
        .catch((err: any) => {
          openToast({
            content: "Failed to save data",
            type: "error",
          });
        });
    } else {
      post("/management/publish", payload)
        .then((response: any) => {
          openToast({
            content: status == "DRAFT" ? "Data saved successfully" : "Data Sent for Review",
            type: "success",
          });
          if (response.status === "OK" && status == "PENDING") {
            navigate("/centralized/status-information?activeTab=pending");
          } else {
            navigate("/centralized/status-information?activeTab=draft");
          }
          // refetchDocument();
        })
        .catch((err: any) => {
          openToast({
            content: "Failed to save data",
            type: "error",
          });
        });
    }
  };

  return (
    <ContentWrapper
      // loading={isLoadingNews}
      title={`${query.get("id") || query.get("editId") ? "Edit" : "Add New"} Single Cabin Luggage Policy Page Image`}
      showBack
    >
      <DynamicForm
        isLoading={isLoadingNews || drilldownLoading}
        config={newsFormConfig}
        onSubmit={(data, buttonValue, reviewNotes) =>
          onSubmit(
            data,
            `${query.get("editId") || query.get("type") === "update" ? `${centralizedHost}/api/baggage/single-cabin/section-two/${editNewsData?.[0]?.id || newsById?.payload?.id}` : `${centralizedHost}/api/baggage/single-cabin/section-two`}`,
            `${query.get("editId") || query.get("type") === "update" ? "UPDATE" : "CREATE"}`,
            `${query.get("editId") || query.get("type") === "update" ? "PATCH" : "POST"}`,
            buttonValue == "save" ? "DRAFT" : "PENDING",
            reviewNotes
          )
        }
        defaultReviewNotes="Kindly review this Baggage Guide"
      />
    </ContentWrapper>
  );
};
